import { render, staticRenderFns } from "./FloorAreaDiningRoom.vue?vue&type=template&id=2b6988bc&"
import script from "./FloorAreaDiningRoom.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaDiningRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports